/* eslint-disable @typescript-eslint/camelcase */
export const userInfoMock = {
  bantime: 0,
  birthday: '',
  province: '',
  nickname: 'sink87HdWW',
  sex: 1,
  rtype: '100',
  uuid: 'a3ff8d128c3a4410ba457aa4dc42bb6d',
  firsttime: 0,
  loginaccount: 'QQ_awFCdf3zAmX2',
  ticket: '9F55AC626BD53DE4B9E1FFE9C6F4E1AD',
  iscert: 1,
  city: '',
  vipinfo: {
    growth: {
      level: 0,
      score: 0,
    },
    isvip: 1,
    type: '0',
    platform: 'mpp',
  },
  banned: 0,
  isValidated: 1,
  email: 'QQ_awFCdf3zAmX2@hifly.tv',
  mobile: '13185023671',
  isband: 1,
  avatar: {
    s: 'https://mgtv-bbqn.oss-cn-beijing.aliyuncs.com/17/2107161101297AFE/57860.jpeg?x-oss-process=style/small',
    l: 'https://mgtv-bbqn.oss-cn-beijing.aliyuncs.com/17/2107161101297AFE/57860.jpeg?x-oss-process=style/large',
    xl: 'https://mgtv-bbqn.oss-cn-beijing.aliyuncs.com/17/2107161101297AFE/57860.jpeg',
    m: 'https://mgtv-bbqn.oss-cn-beijing.aliyuncs.com/17/2107161101297AFE/57860.jpeg?x-oss-process=style/medium',
  },
  introduction: '',
  logintype: 0,
}

export const deviceInfoMock = {
  osVersion: '10.0.2',
  gps: '',
  ch: 'appstore',
  time: '20181011110701',
  pushSwitch: '0',
  did: '1a84b178be125756396aa9632ac8015d21a582d2',
  guid: '900000000889316400',
  mf: 'Apple',
  channel: 'AppStore',
  appVersion: '6.0.4',
  uuid: '25afaaebe6b940d3936584fbaaba63d6',
  rch: '',
  sver: 'iphone-10.0.2',
  ticket: 'BTCO3B0HD96H7DJSI1KG',
  isdebug: 0,
  IMEI: '',
  aver: 'imgotv-iphone-6.0.4',
  cid: '29a984f84d56fd80b5b2d17d821819cf',
  net: 1,
  sid: '91844BE7-EF6E-4B7B-A0C3-7E842BA7193D',
  mac: '1a84b178be125750396ac9632ac8015d21a582d2',
  mod: 'iPhone8_2',
  rdc: '',
  abroad: '0',
  appBuildVersion: '6.0.4.1809211010',
  p2p: '1',
  dname: 'Jankerli%206S%2B',
  reviewStatus: '0',
  osType: 'ios',
  device: 'iPhone',
  idfa: 'B86073DA-5105-4FF1-84A8-FA1DCD9342DA',
}

export const commentListData = {
  total: 2,
  list: [
    {
      date: '4天前',
      praise_num: '1.1w',
      reply_list: [
        {
          date: '1天前', //日期
          comment_id: 251767067, //评论id
          comment_id_str: 251767067, //评论id
          praise_num: '', //点赞数
          user: {
            //用户信息
            level: 1, //用户等级
            nickname: '蓝蓝05ZUxe', //用户昵称
            account_type: 0, //账号类型
            photo:
              'https://avatar.hitv.com/5/1406dd4e/bke4ets7mq0pfbeijo5g?x-oss-process=style/medium', //头像
            uuid: '1406dd4ebc9147bc8d513aabc861429c', //uuid
          },
          to_user: {
            //回复的人的
            level: 1, //用户等级
            nickname: '蓝蓝05ZUxe', //用户昵称
            account_type: 0, //账号类型
            photo:
              'https://avatar.hitv.com/5/1406dd4e/bke4ets7mq0pfbeijo5g?x-oss-process=style/medium', //头像
            uuid: '1406dd4ebc9147bc8d513aabc861429c', //uuid
          },
          content: '你说的很好', //回复内容
        },
      ],
      content: '我也觉得，问着都好吃',
      subject_title: '芒果崽9块9包邮',
      comment_id: 70014866,
      comment_id_str: '70014866',
      user: {
        level: 5,
        nickname: '哇哈哈888',
        account_type: 0,
        photo:
          'https://avatar.hitv.com/WB4jZ2bLVmyDeLiKZA4bfhMhJwHTZT.jpg?x-oss-process=style/medium',
        uuid: 'd1df024af811424ab04d1c0dbf02dd92',
      },
    },
  ],
}
